/**
 * Illustrations sub-navigation.
 *
 * On single illustration pages the sub-nav is a horizontal scroller on mobile.
 * Scroll the active item into view on load so the current illustration is
 * visible even when it sits far along the row (e.g. the last item).
 */
const initIllustrationsSubNav = () => {
  const scroller = document.querySelector('.sub-menu-header');

  if (!scroller) {
    return;
  }

  const active = scroller.querySelector('.sub-menu-item-header.active');

  if (!active) {
    return;
  }

  const scrollActiveIntoView = () => {
    const scrollerRect = scroller.getBoundingClientRect();
    const activeRect = active.getBoundingClientRect();
    const offsetWithin = activeRect.left - scrollerRect.left + scroller.scrollLeft;

    // Centre the active item; the browser clamps to the max scroll, so the last
    // item ends up flush to the right edge.
    const target = offsetWithin - (scroller.clientWidth - active.offsetWidth) / 2;

    scroller.scrollLeft = Math.max(0, target);
  };

  scrollActiveIntoView();
  window.addEventListener('resize', scrollActiveIntoView);
};

export default initIllustrationsSubNav;
